import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/ForgotPassword.css';
import logoApp from '../images/logo-app.png'
import '../styles/Logo.css';

  const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      setMessage('Un momento por favor.');
      await axios.post('https://services.neuralactions.com/api/saas_forgot_password', { email });
      // await axios.post('http://localhost:8882/rafa_forgot_password', { email });
      setMessage('Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.');
    } catch (error) {
      setMessage('Hubo un error. Inténtalo nuevamente.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Generar nueva contraseña</h2>
        <div>
            <img src={logoApp} className="imagen-logo" alt="NeuralActions Miralls del temps"/>
        </div>
        <form onSubmit={handleReset}>
          <h2>Vamos a generar una nueva contraseña</h2>
          <input 
            type="email" 
            placeholder="Ingresa tu correo" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className="input-field"
          />
          <button type="submit" className="submit-btn">Enviar enlace</button>
        </form>
        {message && <p className="message">{message}</p>}
        
        {/* Botón para volver a login */}
        <button className="back-btn" onClick={() => navigate('/login')}>
        {/* <button className="back-to-login-btn" onClick={() => window.location.href = 'https://saas.neuralactions.com'}> */}
          Ya recordé la contraseña
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
